import React from 'react';
import styled from 'styled-components';
import { Modal } from './Modal';
import { CloseIcon } from './Icons';
import { ClassListContent } from '../Shared/ClassListContent';
import { useClassInsights } from './ClassInsightsContext';
import { catalogClasses } from './catalogSelectors';

const ContentWrap = styled.div`
  position: relative;
  padding: 30px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  line-height: 0;
`;

export function ClassListPopup({ open, onClose }) {
  const { catalog } = useClassInsights();
  const classes = catalogClasses(catalog);

  if (!open) return null;

  return (
    <Modal onOverlayClick={onClose} className="ci-students-modal ci-class-list-modal">
      <ContentWrap>
        <CloseButton type="button" onClick={onClose} aria-label="Close class list popup">
          <CloseIcon />
        </CloseButton>
        <ClassListContent
          classFontSize="16px"
          pinRequestButtonBottom
          classesData={classes}
        />
      </ContentWrap>
    </Modal>
  );
}
